import React, { useEffect, useState } from "react"
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator"
import { bindActionCreators } from "redux"
import {
  deleteKnowmix,
  getKnowmix,
  updateKnowmix,
} from "../../../../../../library/store/actions/creators/knowmixCreators"
import { connect } from "react-redux"
import { withSnackbar } from "notistack"
import { generatePath, Redirect, withRouter } from "react-router-dom"
import getErrorText from "../../../../../../library/constants/errorTypes"
import {
  getArrayByIds,
  getObjectById,
} from "../../../../../../library/utils/arrays"
import {
  calendarGrades,
  grades as gradesList,
  subjects as subjectsList,
} from "../../../../../../library/constants/educationalDictionary"
import Button from "@material-ui/core/Button/Button"
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent/DialogContent"
import DialogActions from "@material-ui/core/DialogActions/DialogActions"
import Dialog from "@material-ui/core/Dialog/Dialog"
import * as routes from "../../../../../../library/constants/routes"
import { urlValidation } from "../../../../../../library/utils/validators"
import FileLoader from "../../../../../../components/formComponents/fileLoader"
import DeleteForeverOutlined from "@material-ui/icons/DeleteForeverOutlined"
import AddOutlined from "@material-ui/icons/AddOutlined"
import { prepareDatePickerValue } from "../../../../../../library/utils/dateConvert"
import SubjectPicker from "../../../../../../components/v2/inputs/pickers/subjectPicker"
import withErrorBoundary from "../../../../../../hocs/guards/withErrorBoundary"
import { safeGetEntity } from "../../../../../../library/utils/entities"
import SchoolCalendarPicker from "../../../../../../components/v2/inputs/pickers/schoolCalendarPicker"
import GroupMemberPicker from "../../../../../../components/v2/inputs/pickers/groupMemberPicker"

const KnowmixSettingsMain = (props) => {
  const [values, setValues] = useState({
    name: props.knowmix.currentKnowmix.name,
    instructions: props.knowmix.currentKnowmix.instructions || "",
    grades: getArrayByIds(gradesList, props.knowmix.currentKnowmix.grades),
    grade:
      getObjectById(calendarGrades, props.knowmix.currentKnowmix.grade) || "",
    subjects: getArrayByIds(
      subjectsList,
      props.knowmix.currentKnowmix.subjects
    ),
    // subject: props.knowmix.currentKnowmix.subject || '',
    subject: safeGetEntity(props.knowmix.currentKnowmix.subject),
    links: props.knowmix.currentKnowmix.links || [],
    blobs: props.knowmix.currentKnowmix.blobs || [],
    release_date: prepareDatePickerValue(
      props.knowmix.currentKnowmix.release_date
    ),
    number: props.knowmix.currentKnowmix.number || "",
    // schedule: props.knowmix.currentKnowmix.schedule || '',
    schedule: safeGetEntity(props.knowmix.currentKnowmix.schedule),
    teacher: safeGetEntity(props.knowmix.currentKnowmix.teacher),
    goal: props.knowmix.currentKnowmix.goal || "",
    measurement: props.knowmix.currentKnowmix.measurement || "",
    themes: ["math", "looooooooooooooooong", "science", "all ages"],
    unit: safeGetEntity(props.knowmix.currentKnowmix.unit),
    second_teacher: safeGetEntity(props.knowmix.currentKnowmix.second_teacher),
  })

  const [errors, setErrors] = useState({
    gradesError: false,
    subjectsError: false,
    subjectError: false,
    scheduleError: false,
    teacherError: false,
  })

  const [open, setOpen] = useState(false)
  const [knowmixDeleted, setKnowmixDeleted] = useState(
    props.knowmix.currentKnowmix.deleted
  )
  const isPublic = props.knowmix.currentKnowmix.is_finished

  useEffect(() => {
    ValidatorForm.addValidationRule("isLink", (value) => urlValidation(value))
  }, [])

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value })
  }

  const handleDateChange = (name, date) => {
    setValues({ ...values, [name]: date })
  }

  const handleChangeRequired = (name) => (event) => {
    setErrors({
      ...errors,
      [name + "Error"]: !event.target.value,
    })
    handleChange(name)(event)
  }
  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const validateSelects = () => {
    const { grades, subjects, subject, grade } = values
    setErrors({
      ...errors,
      gradesError: !grades.length,
      subjectsError: !subjects.length,
      subjectError: !subject,
      // gradeError: !grade,
    })
  }

  const handleFileInputOpen = (id) => {
    document.getElementById(id).click()
  }

  const setBlobs = ({ blobs, blobsInfo }) => {
    setValues({ ...values, blobs, blobsInfo })
  }

  const handleLinkChange = ({ index, fieldName, value }) => {
    const newLinks = values.links.map((item, i) =>
      i === index
        ? {
            ...item,
            [fieldName]: value,
          }
        : item
    )
    setValues({ ...values, links: newLinks })
  }

  const addLink = () => {
    setValues({ ...values, links: [...values.links, { url: "", title: "" }] })
  }

  const deleteLink = (index) => {
    const newLinks = values.links.filter((item, i) => i !== index)

    setValues({ ...values, links: newLinks })
  }

  const processInfoSave = async () => {
    const id = parseInt(props.match.params.knowmixId)
    const {
      name,
      grade,
      subject,
      instructions,
      links,
      blobs,
      schedule,
      goal,
      measurement,
    } = values

    if (errors.subjectError || errors.scheduleError) return

    try {
      await props.updateKnowmix({
        id: parseInt(props.match.params.knowmixId),
        name,
        // grades: grades.map((g) => g.id),
        // grade: grade.id,
        subject_id: subject.id,
        // subjects: subjects.map((s) => s.id),
        instructions,
        links,
        blobs: blobs.map((file) => file.id),
        // schedule_id: schedule.id,
        teacher_id: values.teacher.id,
        goal: goal,
        measurement: measurement,
      })
      await props.enqueueSnackbar("Information updated", { variant: "success" })
      await props.getKnowmix({ id })
    } catch ({ error }) {
      props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
  }

  const processKnowmixDelete = async () => {
    const id = parseInt(props.match.params.knowmixId)

    try {
      await props.deleteKnowmix({ id })
      await props.enqueueSnackbar("Course deleted", { variant: "success" })
      setKnowmixDeleted(true)
    } catch ({ error }) {
      props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
  }

  if (knowmixDeleted) {
    return (
      <Redirect
        to={generatePath(routes.KNOWMIX, {
          knowmixId: parseInt(props.match.params.knowmixId),
        })}
      />
    )
  }

  return (
    <div className="box">
      <div className="box__heading">Main information</div>
      <div className="box__content">
        <ValidatorForm className="form" onSubmit={processInfoSave}>
          <div className="form__fieldset">
            <label htmlFor="name" className="form__label">
              Course name *
            </label>
            <div className="form__fieldbox">
              <div className="form__input form__input--select">
                <TextValidator
                  id="name"
                  name="name"
                  value={values.name}
                  placeholder="Type course name"
                  className="edit-form__input"
                  margin="normal"
                  fullWidth
                  // disabled={isPublic}
                  validators={[
                    "required",
                    "minStringLength:3",
                    "maxStringLength:200",
                  ]}
                  errorMessages={[
                    "Field is required",
                    "Min length is 3 characters",
                    "Max length is 200 characters",
                  ]}
                  withRequiredValidator
                  onChange={handleChange("name")}
                />
              </div>
            </div>
          </div>

          <div className="form__fieldset">
            <label htmlFor="instructions" className="form__label">
              Info
            </label>
            <div className="form__fieldbox">
              <div className="form__input">
                <TextValidator
                  id="instructions"
                  name="instructions"
                  value={values.instructions}
                  placeholder="Type info"
                  className="edit-form__input"
                  margin="normal"
                  fullWidth
                  multiline
                  validators={["maxStringLength:5000"]}
                  errorMessages={["Max length is 5000 characters"]}
                  onChange={handleChange("instructions")}
                  // disabled={isPublic}
                />
              </div>
            </div>
          </div>

          <div className="form__fieldset">
            <label htmlFor="goal" className="form__label">
              Goal
            </label>
            <div className="form__fieldbox">
              <div className="form__input">
                <TextValidator
                  id="goal"
                  name="goal"
                  value={values.goal}
                  placeholder="Type goal"
                  className="edit-form__input"
                  margin="normal"
                  fullWidth
                  validators={["maxStringLength:200"]}
                  errorMessages={["Max length is 200 characters"]}
                  onChange={handleChange("goal")}
                  // disabled={isPublic}
                />
              </div>
            </div>
          </div>

          <div className="form__fieldset">
            <label htmlFor="measurement" className="form__label">
              Measurement
            </label>
            <div className="form__fieldbox">
              <div className="form__input">
                <TextValidator
                  id="measurement"
                  name="measurement"
                  value={values.measurement}
                  placeholder="Type measurement"
                  className="edit-form__input"
                  margin="normal"
                  fullWidth
                  validators={["maxStringLength:200"]}
                  errorMessages={["Max length is 200 characters"]}
                  onChange={handleChange("measurement")}
                  // disabled={isPublic}
                />
              </div>
            </div>
          </div>

          <GroupMemberPicker
            value={values.teacher}
            onChange={handleChangeRequired("teacher")}
            hasError={errors.teacherError}
            required
            // disabled={isPublic}
            groupId={props.knowmix.currentKnowmix.creator_group.id}
            // role={2}
            tags={[2]}
            userLabel={"teacher"}
          />

          {/*<GroupMemberPicker*/}
          {/*  value={values.second_teacher}*/}
          {/*  onChange={handleChangeRequired("second_teacher")}*/}
          {/*  // disabled={isPublic}*/}
          {/*  groupId={props.knowmix.currentKnowmix.creator_group.id}*/}
          {/*  // role={2}*/}
          {/*  tags={[2]}*/}
          {/*  userLabel={"second teacher"}*/}
          {/*  disabledValues={[values.teacher]}*/}
          {/*  disabledValueMessage={"Already a teacher"}*/}
          {/*/>*/}

          {!!props.knowmix.currentKnowmix.creator_group && (
            <SchoolCalendarPicker
              groupId={props.knowmix.currentKnowmix.creator_group.id}
              hasError={errors.scheduleError}
              onChange={handleChangeRequired("schedule")}
              value={values.schedule}
              required
              // disabled={!!values.schedule || isPublic}
              disabled={!!values.schedule}
            />
          )}

          <SubjectPicker
            value={values.subject}
            required
            hasError={errors.subjectError}
            onChange={handleChangeRequired("subject")}
            // disabled={isPublic}
            scheduleId={
              !values.schedule.has_district_calendar
                ? values.schedule.id
                : undefined
            }
            calendarId={
              values.schedule.has_district_calendar
                ? values.schedule.calendar_id
                : undefined
            }
          />

          {/*<UnitPicker*/}
          {/*  value={values.unit}*/}
          {/*  onChange={(u) =>*/}
          {/*    setValues((prevState) => ({ ...prevState, unit: u }))*/}
          {/*  }*/}
          {/*  subjectId={values.subject.id}*/}
          {/*/>*/}

          {/*<FormDatePicker*/}
          {/*  dateFrom={{*/}
          {/*    label: 'Release date',*/}
          {/*    value: values.release_date,*/}
          {/*    handleChange: (value) => handleDateChange('release_date', value),*/}
          {/*  }}*/}
          {/*/>*/}

          {/*{((values.links.length > 0 && isPublic) || !isPublic) && (*/}
          {
            <div className="form__fieldset">
              <label className="form__label">Links</label>
              <div className="form__fieldbox">
                <div className="form__input-group">
                  {values.links.map((item, index) => (
                    <div
                      key={index}
                      className={index < values.links.length - 1 ? "mb15" : ""}
                    >
                      <div className="form__controllable-input">
                        <div className="form__input">
                          <TextValidator
                            name={`link-title-${index + String(new Date())}`}
                            value={item.title}
                            placeholder={"Type link title"}
                            className="edit-form__input"
                            margin="normal"
                            fullWidth
                            validators={["required", "maxStringLength:250"]}
                            errorMessages={[
                              "Field is required",
                              "Max length is 250 characters",
                            ]}
                            onChange={(event) => {
                              handleLinkChange({
                                index,
                                fieldName: "title",
                                value: event.target.value,
                              })
                            }}
                            // disabled={isPublic}
                          />
                        </div>
                        <button
                          className="form__manage-input"
                          type="button"
                          onClick={() => deleteLink(index)}
                        >
                          <DeleteForeverOutlined /> Delete
                        </button>
                      </div>
                      <div className="form__controllable-input">
                        <div className="form__input">
                          <TextValidator
                            name={`link-url-${index + String(new Date())}`}
                            value={item.url}
                            placeholder={"Type URL"}
                            className="edit-form__input"
                            margin="normal"
                            fullWidth
                            validators={[
                              "required",
                              "isLink",
                              "maxStringLength:250",
                            ]}
                            errorMessages={[
                              "Field is required",
                              "Invalid URL",
                              "Max length is 250 characters",
                            ]}
                            onChange={(event) => {
                              handleLinkChange({
                                index,
                                fieldName: "url",
                                value: event.target.value,
                              })
                            }}
                            // disabled={isPublic}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {/*{values.links.length < 5 && !isPublic && (*/}
                {values.links.length < 5 && (
                  <button
                    className="form__add-input"
                    type="button"
                    onClick={addLink}
                  >
                    <AddOutlined /> Add link
                  </button>
                )}
              </div>
            </div>
          }

          {/*{((values.blobs.length > 0 && isPublic) || !isPublic) && (*/}
          {
            <div className="form__fieldset">
              <span className="form__label">Attachments</span>
              <div className="form__fieldbox">
                <div className="form__attachments">
                  <FileLoader
                    attachmentId={"blobs"}
                    blobs={
                      values.blobsInfo
                        ? values.blobsInfo.map((b, i) => {
                            return {
                              id: values.blobs[i]
                                ? values.blobs[i].id
                                : undefined,
                              name: b.name,
                              lastModified: b.lastModified,
                              lastModifiedDate: b.lastModifiedDate,
                              webkitRelativePath: b.webkitRelativePath,
                              size: b.size,
                              type: b.type,
                              key: b.key,
                            }
                          })
                        : values.blobs
                    }
                    onUpload={setBlobs}
                    token={props.auth.userData.token}
                    attachmentOnly={true}
                    limit={10}
                    // disabled={isPublic}
                  />

                  {/*{!!values.blobs && values.blobs.length < 10 && !isPublic && (*/}
                  {!!values.blobs && values.blobs.length < 10 && (
                    <Button
                      color="primary"
                      variant="outlined"
                      className={`${!!values.blobs.length ? "mt10" : ""}`}
                      onClick={() => handleFileInputOpen("blobs")}
                    >
                      Upload
                    </Button>
                  )}
                </div>
              </div>
            </div>
          }

          {/*<TagsInput*/}
          {/*  value={values.themes}*/}
          {/*  onChange={(v) =>*/}
          {/*    setValues((prevState) => ({ ...prevState, themes: v }))*/}
          {/*  }*/}
          {/*  label={"Themes"}*/}
          {/*  limit={8}*/}
          {/*  entityName={"theme"}*/}
          {/*/>*/}

          {/*{!isPublic && (*/}
          <Button
            color="primary"
            variant="contained"
            type="submit"
            className="form__submit mb15"
            onClick={validateSelects}
          >
            Save
          </Button>
          {/*)}*/}
          <div className="form__divider"></div>
          <div className="f jcc aic color-black-54">
            <div>
              You can{" "}
              <span className="link link--inline" onClick={handleClickOpen}>
                delete this course.
              </span>
            </div>
          </div>
        </ValidatorForm>
      </div>
      {open && (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Delete course?</DialogTitle>
          <DialogContent>
            <p className="color-black-54 font-16">
              If you delete course you will not be able to view information on
              the site. You can restore course only through the support site.
            </p>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Decline
            </Button>
            <Button onClick={processKnowmixDelete} color="primary" autoFocus>
              Accept
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  )
}

const mapStateToProps = ({ auth, knowmix }) => ({ auth, knowmix })
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getKnowmix,
      updateKnowmix,
      deleteKnowmix,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(withRouter(withErrorBoundary(KnowmixSettingsMain))))
